//@ts-check
import React from 'react';
import { MuiThemeProvider, withStyles, createStyles, StylesProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createGenerateClassName } from '@material-ui/core/styles';
import createGenerateClassNameDeterministic from './createGenerateClassNameDeterministic';
import './globalStyles';
import createTheme from './createTheme';
var generateClassName = createGenerateClassName();
var generateClassNameDeterministic = createGenerateClassNameDeterministic();
/**
 * @param {import('./types').ThemeProviderProps} props
 */

function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var appTheme = createTheme(theme);
  return React.createElement(StylesProvider, {
    generateClassName: theme.deterministicClasses ? generateClassNameDeterministic : generateClassName
  }, React.createElement(MuiThemeProvider, {
    theme: appTheme
  }, React.createElement(CssBaseline, null), React.createElement(BodyStyle, null), children));
}

var BodyStyle = withStyles(function (theme) {
  return createStyles({
    '@global': {
      body: {
        backgroundColor: theme.common.Page.Common.style.backgroundColor,
        color: theme.common.Page.Common.style.color ? theme.common.Page.Common.style.color : theme.palette.getContrastText(theme.common.Page.Common.style.backgroundColor)
      },
      '@global': {
        '@keyframes FormErrorModalFix': {
          from: {
            opacity: 0
          },
          '50%': {
            opacity: 0
          },
          '50.1%': {
            opacity: 1
          },
          to: {
            opacity: 1
          }
        }
      }
    }
  });
})(function () {
  return null;
});
export default ThemeProvider;